import React from 'react'

const LeftWrapper = ({ children, className, custom, ...rest }) => {
    return (
        <div className={` ${!custom && 'col-12 col-md-6 px-2 ps-md-0'} ${className || ''}`} {...rest}>{children || ''}</div>
    )
}

export default LeftWrapper